interface LogoProps {
  className?: string;
}

export function G10MacroRatesLogo({ className = "w-full h-full" }: LogoProps) {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 50 50"
      className={className}
    >
      <path 
        fill="currentColor" 
        d="M46,21.3c-4.6-4.9-9.2-9.8-13.8-14.7-.6-.7-1-.7-1.7,0-2.6,2.8-5.2,5.6-7.8,8.4-.2.2-.4.3-.7.2-2.5-.7-5-.7-7.5,0-7.4,1.9-12.1,9.3-10.7,16.8,1.4,8,9.1,13.3,17.1,11.8,1.5-.3,2.9-.8,4.2-1.4.3-.1.5-.2.8-.2,3.7,0,7.4,0,11.1,0s.3,0,.5,0c.4,0,.7-.4.7-.8,0-1,0-2,0-3v-15.4h.5c2.2,0,4.3,0,6.5,0,.5,0,.9-.2,1.1-.6v-.5c-.2-.2-.3-.4-.4-.5h0ZM18.2,42.3c-7.2,0-13-5.9-13-13.1,0-7.2,5.9-13,13-12.9,7.2,0,13,5.9,13,13,0,7.2-5.9,13-13,13h0ZM43.1,21.2h-5.3c-.9,0-1.2.2-1.2,1.2v17.9h-8.7c3.9-3.7,5.6-8.1,4.8-13.3-.8-5.2-3.8-8.9-8.6-11.2l7.2-7.7,12.3,13.1h-.5,0Z" 
      />
      <path 
        fill="currentColor" 
        d="M29.6,29.3c0,6.2-5.1,11.3-11.3,11.3s-11.3-5.1-11.3-11.3h0c0-6.2,5.1-11.3,11.3-11.3,6.2,0,11.3,5.1,11.3,11.3h0ZM27.9,29.3c0-5.3-4.3-9.6-9.6-9.6-5.3,0-9.7,4.3-9.7,9.6,0,5.3,4.3,9.6,9.6,9.6,5.3,0,9.7-4.3,9.7-9.6h0s0,0,0,0Z" 
      />
      <path 
        fill="currentColor" 
        d="M22.8,34.7c-.2-.1-.5-.3-.7-.4-2.9-2.9-5.9-5.8-8.8-8.8-.4-.3-.4-.8-.1-1.2,0,0,0,0,0,0,.3-.3.8-.3,1.2,0s0,0,0,0c3,2.9,5.9,5.9,8.8,8.8.3.2.4.7.2,1-.2.2-.4.4-.7.6h0Z" 
      />
      <path 
        fill="currentColor" 
        d="M14.4,30.6c1.4,0,2.5,1.1,2.5,2.5h0c0,1.4-1.1,2.6-2.5,2.6h0c-1.4,0-2.5-1.1-2.5-2.5,0-1.4,1.1-2.5,2.5-2.5h0ZM14.4,32.3c-.5,0-.8.4-.8.9,0,.5.4.8.9.8.5,0,.8-.4.8-.8h0c0-.5-.4-.8-.8-.8h0Z" 
      />
      <path 
        fill="currentColor" 
        d="M24.6,25.5c0,1.4-1.1,2.5-2.5,2.5h0c-1.4,0-2.5-1.1-2.5-2.5h0c0-1.4,1.1-2.5,2.5-2.5,1.4,0,2.5,1.1,2.5,2.5,0,0,0,0,0,0ZM22.1,26.3c.5,0,.8-.4.8-.8h0c0-.5-.4-.9-.8-.9-.5,0-.9.4-.9.8,0,.5.4.8.8.8h0Z" 
      />
    </svg>
  );
}